import { Module } from "vuex";

declare interface MenuItem {
  name: string;
  path: string;
  permissions: Array<string>;
  order: number;
  icon?: any;
  indexPage?: Array<string>;
}

const storeOption: Module<{ menus: Array<MenuItem> | null }, any> = {
  namespaced: true,
  state: {
    menus: [
      {
        name: "专利管理",
        path: "patents",
        permissions: ["PATENT"],
        order: 100,
        icon: require("../../../assets/images/menus/monitor.png")
      }
    ]
  },
  getters: {
    menus: (state: any) => (user: any) => {
      const menus = state.menus || [];
      return JSON.parse(JSON.stringify(menus)).sort((m1: MenuItem, m2: MenuItem) => m1.order - m2.order);
    }
  }
};

export default storeOption;
